import { render, staticRenderFns } from "./ItemsRow.vue?vue&type=template&id=ad2055ac&scoped=true"
import script from "./ItemsRow.vue?vue&type=script&lang=js"
export * from "./ItemsRow.vue?vue&type=script&lang=js"
import style0 from "./ItemsRow.vue?vue&type=style&index=0&id=ad2055ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2055ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad2055ac')) {
      api.createRecord('ad2055ac', component.options)
    } else {
      api.reload('ad2055ac', component.options)
    }
    module.hot.accept("./ItemsRow.vue?vue&type=template&id=ad2055ac&scoped=true", function () {
      api.rerender('ad2055ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemsRow.vue"
export default component.exports